import React, { useEffect, useState } from "react";
// import Banner from "../components/common/banner";
import { Button, Card, Col, Container, Form, Modal, Row, Toast } from "react-bootstrap";
import { postData } from "../api";
import '../assets/css/style.css'
// import banner from "../assets/images/aboutUspage/about-us-bg.svg";

function Career() {
  const inputStyle = {
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    width: "100%",
  };

  const inputStyleFocus = {
    ...inputStyle,
    border: "none",
    outline: "1px solid #ccc",
  };

  const [career, setCareer] = useState(null);
  const [show, setShow] = useState(false);
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDetails, setShowDetails] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [currentJobId, setCurrentJobId] = useState(null);

  useEffect(() => {
    const careerList = async () => {
      const url = `${process.env.REACT_APP_BASEURL}/admin/career/get`;
      const result = await postData(url, {});

      if (result.data.data) {
        // setCareer(result.data.data);
      }
    };
    careerList();
  }, []);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let formData = new FormData();
      formData.append("careerId", currentJobId);
      formData.append("firstName", firstName);
      formData.append("email", email);
      formData.append("mobile", mobile);
      if (selectedFile) {
        formData.append("file", selectedFile);
      }

      const url = `${process.env.REACT_APP_BASEURL}/admin/applyjob/create`;
      const result = await postData(url, formData);

      if (result.status) {
        setMessage("Job applied successfully");
        setShow(true);
        setShowModal(false);

        setTimeout(() => {
          setLoading(false);
          window.location.reload();
        }, 3000);
      } else {
        throw new Error(result);
      }
    } catch (err) {
      setMessage("Job application failed");
      setAlert(true);
      setShowModal(false);

      setTimeout(() => {
        setLoading(false);
        window.location.reload();
      }, 3000);
    }
  };

  const handleToggleDetails = (id) => {
    setShowDetails((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const handleShowModal = (id) => {
    setCurrentJobId(id);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {/* <div className="breatcome_area" > */}
      {/* <img src={banner} alt="banner"  className="img-fuild"/> */}
      {/* <div className="text_overlay">
    <h2>Career</h2>
    <p>Home || Career</p>
  </div> </div> */}
      <section className="career-section pt-60 pb-50 mt-header">
        <Container>
          <Row>
            <Col md={12}>
              <div className="section-header text-center mb-5">
                <div className="banner-badge mb-3">Join Our Team</div>
                <h1 className="banner-title mb-4" style={{ fontSize: '3rem', fontWeight: 800 }}>
                  Explore <span className="gradient-text">Opportunities</span>
                </h1>
                <p className="text-muted mx-auto" style={{ maxWidth: '600px', fontSize: '1.1rem' }}>
                  Join our team of innovators and creators. We're looking for passionate 
                  individuals to help us build the future of technology.
                </p>
              </div>
              
              <Row className="g-4">
              {career && career.length > 0 ? (
                career.map((item, i) => {
                  let responsibilities = item.responsibilities.split("\n");
                  return (
                    <Col lg={6} key={i}>
                      <div className="job-card">
                        <div className="job-title">
                          {item.title}
                          <span className="job-type-badge">{item.type}</span>
                        </div>
                        
                        <div className="job-info">
                          We are looking for a {item.position} with at least {item.experience} years 
                          of experience and {item.eduction} education.
                        </div>

                        <div className="job-location">
                          <i className="fa-regular fa-location-dot text-primary"></i>
                          {item.location}
                        </div>

                        <div className="d-flex gap-3">
                          <Button 
                            className="modern-btn btn-outline-primary"
                            style={{ 
                              background: showDetails[item._id] ? 'rgba(59, 130, 246, 0.1)' : 'transparent',
                              color: 'var(--primary-color)',
                              border: '1px solid var(--primary-color)'
                            }}
                            onClick={() => handleToggleDetails(item._id)}
                          >
                            {showDetails[item._id] ? 'Hide Details' : 'View Details'}
                          </Button>
                          <Button 
                            className="modern-btn primary border-0"
                            onClick={() => handleShowModal(item._id)}
                          >
                            Apply Now
                          </Button>
                        </div>

                        {showDetails[item._id] && (
                          <div className="job-responsibilities mt-4 pt-3 border-top">
                            <h5>Key Responsibilities</h5>
                            <div className="responsibilities-list">
                              {responsibilities.map((x, index) => (
                                <div className="responsibility-item" key={index}>
                                  <i className="fa-regular fa-check-circle"></i>
                                  <span>{x}</span>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </Col>
                  );
                })
              ) : (
                <Col className="text-center py-5">
                   <div className="empty-state">
                    <i className="fa-regular fa-briefcase fa-3x text-muted mb-3"></i>
                    <h4>No Openings Currently</h4>
                    <p className="text-muted">
                     No job categories available right now—exciting opportunities are coming soon. Stay tuned!
                    </p>
                   </div>
                </Col>
              )}</Row>
            </Col>
          </Row>
        </Container>
      </section>

      <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold ps-2">Apply for Position</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-4">
          <Form onSubmit={handleContactSubmit}>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted small text-uppercase">Full Name</Form.Label>
                  <Form.Control
                    className="modern-input"
                    type="text"
                    value={firstName}
                    name="firstName"
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                    placeholder="Enter your name"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted small text-uppercase">Email Address</Form.Label>
                  <Form.Control
                    className="modern-input"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="name@example.com"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted small text-uppercase">Mobile Number</Form.Label>
                  <Form.Control
                    className="modern-input"
                    type="tel"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    required
                    placeholder="+91 00000 00000"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-4">
                  <Form.Label className="fw-semibold text-muted small text-uppercase">Resume / CV</Form.Label>
                  <Form.Control
                    className="modern-file-input"
                    type="file"
                    name="file"
                    accept=".pdf,.doc,.docx"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                    required
                  />
                  <Form.Text className="text-muted small">
                    Accepted formats: PDF, DOC, DOCX
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>

            <div className="text-end mt-2">
              <Button variant="link" className="text-muted text-decoration-none me-2" onClick={handleCloseModal}>
                Cancel
              </Button>
              <Button type="submit" className="modern-btn primary border-0">
                {loading ? 'Submitting...' : 'Submit Application'}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Toast
        onClose={() => setShow(false)}
        show={show}
        delay={3000}
        autohide
        className="toast"
        bg="success"
      >
        <Toast.Body>{message && message}</Toast.Body>
      </Toast>
      <Toast
        onClose={() => setAlert(false)}
        show={alert}
        delay={3000}
        autohide
        className="toast"
        bg="danger"
      >
        <Toast.Body>{message && message}</Toast.Body>
      </Toast>
    </>
  );
}

export default Career;
